import { ModalBasic } from 'design-system/Components/Modal/ModalBasic/ModalBasic'
import styled from 'styled-components'

export const ModalWrapper = styled(ModalBasic)`
  overflow-y: visible;
  overflow-x: unset;
`
